module.exports = __webpack_public_path__ + "img/barka.a3d7270d.avif";